import { useContext } from 'react';
import clsx from 'clsx';
import { CaretLeft, X } from '@hungryroot/icons';
import { Heading, Paragraph, Button, IconButton } from '@hungryroot/ramen';
import { FoodFeedbackModalContext } from '../FoodFeedbackModal';
import styles from './NeedHelpWithYourOrderStage.module.css';
import sharedStyles from '../shared.module.css';

type NeedHelpWithYourOrderStageProps = {
  visible: boolean;
  prevStage?: () => void;
  nextStage?: () => void;
  dismissModal: () => void;
};

export function NeedHelpWithYourOrderStage(
  props: NeedHelpWithYourOrderStageProps
) {
  const { prevStage, dismissModal, nextStage, visible } = props;

  const { issues } = useContext(FoodFeedbackModalContext);

  return (
    <div
      className={clsx(
        sharedStyles['visibility-transition'],
        styles['need-help-stage']
      )}
      data-visible={visible || null}
    >
      <div className={sharedStyles.header}>
        <IconButton
          className={clsx({
            [sharedStyles['prev-stage-button']]: true,
            [sharedStyles['show-prev-stage-button']]: Boolean(prevStage),
          })}
          style="muted"
          prominence="tertiary"
          size="medium"
          icon={<CaretLeft />}
          onClick={prevStage}
          ariaLabel="Previous stage"
        />

        <IconButton
          style="muted"
          prominence="tertiary"
          size="medium"
          icon={<X />}
          onClick={dismissModal}
          ariaLabel="Dismiss modal"
        />
      </div>
      <div className={styles['body-content']}>
        <img
          src="/img/rating/basket_self_serve.svg"
          alt="Basket of products"
          width="140px"
          height="140px"
        />
        <Heading
          className={styles['need-help-stage-heading-text']}
          variant="H1Alt"
        >
          Need help with an order?
        </Heading>
        <Paragraph
          className={styles['need-help-stage-body-text']}
          variant="lead"
        >
          We noticed you had an item issue, and we're here to help!
        </Paragraph>
      </div>

      <div className={styles['need-help-stage-button-group']}>
        <Button
          className={styles['need-help-stage-button-help']}
          prominence="primary"
          size="medium"
          style="default"
          centerContent={true}
          onClick={() => {
            if (issues) {
              // Redirect the user to the delivery help page if there are issues
              // spanning multiple orders. Otherwise, if they only have issues
              // with a single order, redirect them to the delivery help page for
              // that order.
              issues.size > 1
                ? (window.location.href = '/delivery-help/')
                : (window.location.href = `/delivery-help/${
                    issues.values().next().value
                  }/`);
            }
          }}
        >
          Get help
        </Button>

        <Button
          className={styles['need-help-stage-button-thanks']}
          prominence="secondary"
          size="medium"
          style="default"
          centerContent={true}
          onClick={nextStage}
        >
          No, thanks
        </Button>
      </div>
    </div>
  );
}
